/* ==========================================================================
   Kollektionsseiten — Beschreibung einklappen

   Der Text bleibt vollständig im Dokument, wird aber auf wenige Zeilen
   begrenzt, damit die Produkte oberhalb der Falz liegen. Die Begrenzung setzt
   erst dieses Skript: ohne JavaScript ist der Text offen und vollständig
   lesbar, statt abgeschnitten und ohne Bedienelement zu sein.
   ========================================================================== */
(function () {
  var text = document.querySelector(".js-collection-text");
  if (!text) return;

  // Medienblöcke werden im Auszug ausgeblendet. Drei Kollektionen beginnen mit
  // einem YouTube-Video: eingeklappt war davon nur ein waagerecht halbierter
  // grauer Kasten zu sehen ("Inhalte blockiert" vom Cookie-Werkzeug) und kein
  // einziger lesbarer Satz. Der Auszug soll Text zeigen, nicht Bruchstücke.
  var medien = [];
  [].forEach.call(text.children, function (kind) {
    if (kind.querySelector("iframe, img, video, table") || /^(FIGURE|TABLE|IFRAME|IMG|VIDEO)$/.test(kind.tagName)) {
      kind.classList.add("collection-banner__medien");
      medien.push(kind);
    }
  });

  // Bleibt nach Abzug der Medien kaum Text übrig, wäre der Auszug leer -
  // dann lieber alles offen lassen.
  var reintext = 0;
  [].forEach.call(text.children, function (kind) {
    if (medien.indexOf(kind) === -1) reintext += kind.textContent.trim().length;
  });
  if (reintext < 200) return;

  // Kurze Texte bleiben, wie sie sind - ein Aufklapper für vier Zeilen nervt.
  var grenze = 190; // Pixel; entspricht etwa sieben Zeilen
  if (text.scrollHeight <= grenze) return;

  text.classList.add("is-clamped");

  var knopf = document.createElement("button");
  knopf.type = "button";
  knopf.className = "collection-banner__more";
  knopf.setAttribute("aria-expanded", "false");
  knopf.setAttribute("aria-controls", "kollektionstext");
  text.id = "kollektionstext";

  var beschriftung = document.createElement("span");
  var pfeil = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  pfeil.setAttribute("viewBox", "0 0 24 24");
  pfeil.setAttribute("aria-hidden", "true");
  pfeil.innerHTML = '<path d="M20 8.5 12.5 16 5 8.5" stroke="currentColor" stroke-width="1.5" fill="none"/>';

  function zeichne(offen) {
    beschriftung.textContent = offen ? "Weniger anzeigen" : "Mehr erfahren";
    knopf.setAttribute("aria-expanded", String(offen));
  }
  zeichne(false);
  knopf.appendChild(beschriftung);
  knopf.appendChild(pfeil);

  knopf.addEventListener("click", function () {
    var offen = text.classList.toggle("is-clamped") === false;
    zeichne(offen);
    if (!offen) text.scrollIntoView({ block: "nearest" });
  });

  text.parentNode.appendChild(knopf);
})();
